import { useEffect, useState, useCallback } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';

/**
 * Botón para alternar pantalla completa.
 * - targetRef (opcional): un ref a un contenedor específico; si no, usa <html>.
 */
export default function FullscreenToggleButton({ sx, targetRef }) {
  const [isFs, setIsFs] = useState(Boolean(document.fullscreenElement));

  const getTarget = () => targetRef?.current ?? document.documentElement;

  const enterFs = useCallback(async () => {
    try {
      await getTarget().requestFullscreen(); // requiere gesto del usuario
    } catch (e) {
      console.error('No se pudo entrar a fullscreen', e);
    }
  }, [targetRef, getTarget]);

  const exitFs = useCallback(async () => {
    try {
      if (document.fullscreenElement) {
        await document.exitFullscreen();
      }
    } catch (e) {
      console.error('No se pudo salir de fullscreen', e);
    }
  }, []);

  const toggle = useCallback(() => {
    if (document.fullscreenElement) exitFs();
    else enterFs();
  }, [enterFs, exitFs]);

  useEffect(() => {
    const onChange = () => setIsFs(Boolean(document.fullscreenElement));
    document.addEventListener('fullscreenchange', onChange);
    return () => document.removeEventListener('fullscreenchange', onChange);
  }, []);

  return (
    <Tooltip title={isFs ? 'Salir de pantalla completa' : 'Pantalla completa'}>
      <IconButton color='inherit' onClick={toggle} aria-label='toggle fullscreen' sx={sx}>
        {isFs ? <FullscreenExitIcon /> : <FullscreenIcon />}
      </IconButton>
    </Tooltip>
  );
}
